import React from "react";
import PageTemplate from "../../componentes/PageTemplate";

export default function Hobbies() {
    return(
        <PageTemplate>
                <h3>Meus hobbies preferidos</h3>
        </PageTemplate>
    )
}